import { Box } from "@husqvarna/ui-core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router";
import { useGetProjectQuery } from "../projectApi";
import {setSelectedProject} from "../projectSlice";
import { skipToken } from "@reduxjs/toolkit/query";

const ProjectLayout = () => {
  const { projectId } = useParams();
  const { data: project } = useGetProjectQuery(projectId ?? skipToken);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (project) {
      dispatch(setSelectedProject(project));
    }
  }, [project]);

  return (
    <Box container width="full">
      <Outlet />      
    </Box>
  );
}
export default ProjectLayout;
